// 3506DeleteYB.js - 医保采购退货删除接口
import {ybRequestTemplate} from "/src/untils/ybRequestTemplate.js"
import {addYbRquestData, getqdNo} from "@/api/yb";
import axios from "axios";
import dayjs from "dayjs";

/**
 * 医保采购退货 (3506)
 * @param {Object} row - 要删除的行数据
 * @param {Object} userData - 用户信息
 * @param {Object} clinicInfo - 诊所信息
 * @param {Function} addStepMessage - 添加步骤消息的函数
 * @param {Function} addOperationStepMessage - 添加操作步骤消息的函数
 * @param {Function} updateOperationProgress - 更新进度条的函数
 * @param {Function} updateOperationStepStatus - 更新步骤状态的函数
 * @returns {Promise} 删除结果
 */

export const deleteMedicalInsurance3506 = async (
  row, 
  userData, 
  clinicInfo, 
  invDataType, // 新增参数
  addStepMessage, 
  addOperationStepMessage, 
  updateOperationProgress,
  updateOperationStepStatus
) => {
  try {
    addStepMessage('开始执行医保信息删除流程(3506)...');
    
    // 准备删除请求数据
    addOperationStepMessage('准备删除请求数据...');
    const ybRequest = JSON.parse(JSON.stringify(ybRequestTemplate));
    const today = dayjs().format('YYYY-MM-DD');
    
    // 获取签到编号
    const signNoRes = await getqdNo();
    let signNo = '';
    if (signNoRes.code === 200) {
      signNo = signNoRes.data.signNo;
      addStepMessage(`签到业务ID: ${signNo}`);
    } else {
      throw new Error('获取签到流水号失败');
    }
    
    // 生成机器ID（截取前20位）
    const machineId = (row.machineId || 'default_machine_id').slice(0, 20);
    
    // 设置请求参数 - 3506接口
    ybRequest.body.infno = '3506';
    ybRequest.body.msgid = `${userData.clinicCode || '000000'}${dayjs().format('YYYYMMDDHHmmss')}${getRandom4Digits()}`;
    ybRequest.body.insuplc_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.mdtrtarea_admvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_sys_code = '007';
    ybRequest.body.infver = 'V1.049';
    ybRequest.body.opter_type = '1';
    ybRequest.body.opter = userData.userId || '1';
    ybRequest.body.opter_name = userData.staffName || '系统操作员';
    ybRequest.body.inf_time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    ybRequest.body.fixmedins_code = userData.clinicCode || '';
    ybRequest.body.fixmedins_name = userData.clinicName || '';
    ybRequest.body.sign_no = signNo;
    
    // 设置退库数据 - 根据3506接口规范，使用传入的采购记录数据
    ybRequest.body.input.selinfo = {
	  fixmedins_hilist_id: row.medinsListCodg || row.fixmedinsHilistId || '', // 定点医药机构目录编号
	  fixmedins_hilist_name: row.medinsListName || '', // 定点医药机构目录名称
      fixmedins_bchno: row.fixmedinsBchno || row.fixmedinsBcHNo || '', // 定点医药机构批次流水号
      // fixmedins_code: userData.clinicCode || '', // 定点医药机构编号
	  medins_list_codg: row.fixmedinsHilistId,
      setl_id: row.setlId || '', // 结算ID medinsProdPurcNo
      mdtrt_sn: row.fixmedinsBchno || row.fixmedinsBcHNo || '', // 就诊流水号
      psn_no: row.opterId || '', // 人员编号 opterId
	  psn_name: userData.staffName || '',
	  psn_cert_type:'01',
      med_list_codg: row.medListCodg || '', // 医疗目录编码
	  certno: row.opterId || '', // 身份证Id
      manu_date: row.manuDate,
	  expy_end: row.expyEnd,

      rx_flag: getRxFlag(row) || '0', // 处方药标志
      trdn_flag: row.trdnFlag || 0, // 拆零标志
	   drugtracinfo: [
		  {
			  drug_trac_codg: ""
		  }
	   ],
      // 添加采购相关的字段
      sel_retn_cnt: row.purcRetnCnt || 0, // 采购/退货数量
      finl_trns_pric: row.finlTrnsPric || 0, // 最终成交单价
      spler_name: row.splerName || '', // 供应商名称
      prodentp_name: row.prodentpName || '', // 生产厂家名称
      manu_lotnum: row.manuLotnum || '', // 生产批号
      aprvno: row.aprvno || '', // 批准文号
      sel_retn_time: row.purcRetnStoinTime || '', // 采购/退货入库时间
      sel_retn_opter_name: userData.staffName || '' // 采购/退货操作人姓名
    };
    
    addStepMessage(`删除数据类型: ${getDataTypeName(invDataType)}`);
    addStepMessage('准备调用接口传输删除数据(3506)...');
    
    // 先传给系统
    const newItem = {
      infno: 3506,
      mdtrtareaAdmvs: userData.mdtrtareaAdmvs || '',
      data: JSON.stringify(ybRequest.body),
      patientId: userData.staffId || '',
      patientName: userData.staffName || '系统操作员'
    };
    
    const res = await addYbRquestData(newItem);
    
    if (res.code !== 200) {
      throw new Error('医保删除数据准备失败: ' + res.message);
    }
    
    addStepMessage('医保删除数据准备完成，开始上传接口(3506)...');
    
    let responseData = res.data;
    if (typeof responseData === 'string') {
      try {
        responseData = JSON.parse(responseData);
      } catch (parseError) {
        throw new Error('解析医保响应数据失败');
      }
    }
    
    // 设置请求头
    ybRequest.headers.infosyscode = responseData.infosyscode || '';
    ybRequest.headers.hsf_signature = responseData.signature || '';
    ybRequest.headers.fixmedins_code = userData.clinicCode || '';
    ybRequest.headers.hsf_nonce = responseData.hsfNonce || '';
    ybRequest.headers.hsf_timestamp = responseData.hsfTimestamp || '';
    
    addStepMessage('调用医保信息删除接口(3506)...');
    updateOperationProgress(70);
    updateOperationStepStatus(1, 'loading');
    
    // 调用医保接口
    const axiosConfig = {
      method: 'post',
      url: process.env.VUE_APP_BASE_YBHOST + `/eapdomain/callService`,
      baseURL: '',
      headers: ybRequest.headers,
      data: ybRequest.body,
    };
    
    const response = await axios(axiosConfig);
    const result = response.data || response;
    
    // 处理响应结果
    if (result.infcode === 0) {
      addStepMessage('医保信息删除成功(3506)', { level: 'success' });
      updateOperationProgress(100);
      updateOperationStepStatus(1, 'success');
      return result;
    } else {
      let errorMsg = '医保信息删除失败(3506)';
      if (result) {
        errorMsg = result.err_msg || result.msg || result.message || '未知错误';
      }
      throw new Error(errorMsg);
    }
    
  } catch (error) {
    console.error('调用医保信息删除接口(3506)异常:', error);
    updateOperationProgress(100);
    updateOperationStepStatus(1, 'error');
    throw error;
  }
};

// 添加辅助函数，用于显示数据类型的名称
function getDataTypeName(invDataType) {
  switch(invDataType) {
    case 1: return '盘存信息(3501)';
    case 2: return '库存变更信息(3502)';
    case 3: return '采购信息(3503/3504)';
    case 4: return '销售信息(3505/3506)';
    default: return '未知类型';
  }
};
/**
 * 生成4位随机数
 * @returns {string} 4位随机数字
 */
const getRandom4Digits = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};
// 添加辅助函数：判断是否为处方药
const getRxFlag = (row) => {
  const rxKeywords = ['抗生素', '麻醉', '精神', '处方', 'RX'];
  const drugName = row.fixmedinsHilistName || '';
  
  return rxKeywords.some(keyword => drugName.includes(keyword)) ? '1' : '0';
};
export default {
  deleteMedicalInsurance3506
};